var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiaries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "-12.915%",
    x2: "169.73%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7190C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#031266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C466C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D27497"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M0 11.286L2.933 5.4 14.667 5.4 17.6 11.286 12.711 19 4.889 19z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.8,
    cy: 4.8,
    r: 4.8,
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    stroke: "#89489B",
    strokeWidth: 0.7,
    opacity: 0.816
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiaries);
export default __webpack_public_path__ + "static/media/beneficiaries.b7e007b2bcf1737284c3774d9ee8f1e4.svg";
export { ForwardRef as ReactComponent };